import { useIntl } from "react-intl";

import { alpha, Box, darken, Typography, useTheme } from "@mui/material";
import CustomIcon from "src/components/custom-icon";

import { Search } from "@mui/icons-material";

export default function HeaderArticleCards({ clientportal }) {
  const intl = useIntl();
  const theme = useTheme();

  const primaryColor = theme.palette.primary.main;

  const accentColor = clientportal.defaultcolor || primaryColor;

  const backgroundGradient = clientportal.defaultcolor
    ? `linear-gradient(135deg, ${clientportal.defaultcolor} 0%, ${darken(clientportal.defaultcolor, 0.15)} 100%)`
    : `linear-gradient(135deg, ${primaryColor} 0%, ${darken(primaryColor, 0.15)} 100%)`;

  {/* Header da seção com gradiente sutil */ }
  return (
    <Box sx={{
      background: backgroundGradient,
      px: { xs: 2.5, sm: 3, md: 4 },
      py: { xs: 2.5, sm: 3 },
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Elemento decorativo de fundo */}
      <Box sx={{
        position: 'absolute',
        top: -20,
        right: -20,
        width: 120,
        height: 120,
        borderRadius: '50%',
        backgroundColor: alpha(accentColor, 1.5),
        pointerEvents: 'none'
      }} />

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, position: 'relative', zIndex: 1 }}>
        {/* Ícone da seção */}
        <Box sx={{
          width: { xs: 44, md: 52 },
          height: { xs: 44, md: 52 },
          borderRadius: '12px',
          backgroundColor: alpha(theme.palette.text.secondary, 0.45),
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backdropFilter: 'blur(10px)',
        }}>
          <CustomIcon icon={Search} color={"#fff"} iconSx={{ fontSize: { xs: 24, md: 28 } }} />
        </Box>

        <Box sx={{ flex: 1 }}>
          <Typography
            variant="h5"
            sx={{
              color: '#fff',
              fontWeight: 700,
              lineHeight: 1.3,
              textShadow: '0 1px 2px rgba(0,0,0,0.1)'
            }}
          >
            {intl.formatMessage({ id: "Resultado da Pesquisa" })}
          </Typography>
        </Box>
      </Box>
    </Box>)
}